import { useTranslation } from "react-i18next";
import type { IbicEditorConfig } from "./ibicModel";
import { WorkflowOptionPicker } from "./WorkflowOptionPicker";

type Props = { options: IbicEditorConfig["options"]; value: string; disabled: boolean; onSelect: (code: string) => void };
export function IbicCodePicker({ options, value, disabled, onSelect }: Props) {
    const { t } = useTranslation();
    return (
        <WorkflowOptionPicker
            options={options.map(option => ({ value: option.code, code: option.code, label: option.label }))}
            value={value}
            disabled={disabled}
            onSelect={onSelect}
            label={t("documentFlow.ibic.label", { defaultValue: "IBIC code" })}
            placeholder={t("documentFlow.ibic.select")}
            searchPlaceholder={t("notes.searchByIbic", { defaultValue: "Search IBIC categories..." })}
            emptyText={t("documentFlow.ibic.noResults", { defaultValue: "No matching IBIC codes" })}
        />
    );
}
